module.exports = __webpack_public_path__ + "img/01.398b1972.jpg";